// extracted by mini-css-extract-plugin
export var container = "dashboard-module--container--DDNTG";
export var dashboard = "dashboard-module--dashboard--k8nA1";
export var header = "dashboard-module--header--SNvWZ";
export var navigation = "dashboard-module--navigation--mh95g";
export var title = "dashboard-module--title--qOXxd";